module.exports = __webpack_public_path__ + "static/media/cross_gray.b2f7c29e.svg";